import { getEnv } from '~/utils';

export const getIndexerUrl = (businessUnit: string) => getEnv(`INDEXER_WEB_URL_${businessUnit}`);
export const getIndexerToken = (businessUnit: string) => getEnv(`INDEXER_WEB_API_TOKEN_${businessUnit}`);
